export default __webpack_public_path__ + "static/media/generating-script.96c025ec.svg";